import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../index";
import { ResponseMetaData, ResponseObjectList } from "../../entities/global";
import { getCohortes } from "./thunks";
import { CohortData } from "../../entities/cohort";


interface CohortState {
  loading: boolean;
  loaded: boolean;
  cohortes: CohortData[];
  cohort?: CohortData;
  meta: ResponseMetaData;
}

const initialState: CohortState = {
  loading: false,
  loaded: false,
  cohortes: [],
  meta: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  }
};

export const cohortSlice = createSlice({
  name: "cohort",
  initialState,
  reducers: {
    onHandlerCohort: (state: Draft<CohortState>, action: PayloadAction<CohortData>) => {
      state.cohort = action.payload;
    },
    onClearState: (state: Draft<CohortState>) => {
      state.cohort = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCohortes.pending, (state: Draft<CohortState>) => {
      state.loading = true;
      state.loaded = false;
    })
    builder.addCase(getCohortes.fulfilled, (state: Draft<CohortState>, action: PayloadAction<ResponseObjectList<CohortData[]>>) => {
      const { data, ...meta } = action.payload;
      state.meta = meta;
      state.cohortes = data;
      state.loading = false;
      state.loaded = true;
    })
    builder.addCase(getCohortes.rejected, (state: Draft<CohortState>) => {
      state.loading = false;
      state.loaded = true;
    })
  },
});

export const { onHandlerCohort, onClearState } = cohortSlice.actions;

export const selectCohortState = (state: RootState) => state.cohort;

export default cohortSlice.reducer;
